import lg from "lightgallery";
import("./lightgallery.scss")

export default {lg};
